import React from 'react'
import {create} from 'zustand'

const useUserStore = create((set) => ({
    user:null,
    setUser:(userData) => set({user:userData}),
    clearUser:()=>set({user:null})
}));

export default useUserStore;
